import type { FilterField } from '@/components/common/AdvancedFilter';
import type { FeedbackType } from '@/features/feedbackTypes/types/feedbackType.types';
import type { ReportingAuthority } from '@/features/users/types/user.types';
import {
  getDateFromToFilterFields,
  getReportingMemberFilterField,
  getZonalManagerFilterField,
} from '@/utils/filterFields';
import {
  FEEDBACK_COMPLETE_FILTER,
  FEEDBACK_COMPLETE_FILTER_LABELS,
  FEEDBACK_FILTER_KEYS,
  FEEDBACK_READ_FILTER,
  FEEDBACK_READ_FILTER_LABELS,
} from '../constants/feedback.constants';

interface GetFeedbackListFilterFieldsArgs {
  feedbackTypes: FeedbackType[] | undefined;
  reportingMembers: ReportingAuthority[] | undefined;
  zonalManagers: ReportingAuthority[] | undefined;
}

export function getFeedbackListFilterFields({
  feedbackTypes,
  reportingMembers,
  zonalManagers,
}: GetFeedbackListFilterFieldsArgs): FilterField[] {
  return [
    getReportingMemberFilterField(reportingMembers, FEEDBACK_FILTER_KEYS.reportingToId),
    getZonalManagerFilterField(zonalManagers, FEEDBACK_FILTER_KEYS.userId),
    {
      key: FEEDBACK_FILTER_KEYS.typeId,
      label: 'Feedback Type',
      type: 'select',
      placeholder: 'All Types',
      options: (feedbackTypes ?? []).map((type) => ({
        label: type.name,
        value: String(type.id),
      })),
    },
    ...getDateFromToFilterFields(),
    {
      key: FEEDBACK_FILTER_KEYS.completeStatus,
      label: 'Complete Status',
      type: 'select',
      placeholder: 'Not Complete',
      options: FEEDBACK_COMPLETE_FILTER.map((status) => ({
        label: FEEDBACK_COMPLETE_FILTER_LABELS[status],
        value: status,
      })),
    },
    {
      key: FEEDBACK_FILTER_KEYS.readStatus,
      label: 'Read',
      type: 'select',
      placeholder: 'All',
      options: FEEDBACK_READ_FILTER.map((status) => ({
        label: FEEDBACK_READ_FILTER_LABELS[status],
        value: status,
      })),
    },
  ];
}
